import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import { useNavigate } from 'hooks/useNavigate';
import DeleteModal from 'components/deleteModalView';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import UIHelper from 'helpers/UIHelper';
import useAcademyArticles from '../useAcademyArticles';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    loading,
    onChangeTableFilter,
    handleDelete,
    handleDownloadExcel,
  } = useAcademyArticles();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <PageHeader title={t('CAPITOLI').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          loading={loading}
          columns={UIHelper.assignTire(columns)}
          dataSource={data.academyArticles}
          pagination={data.pagination}
          onChange={onChangeTableFilter}
          scroll={{ x: 1500 }}
          onRow={(record) => ({
            onClick: () => {
              if (record?.id) {
                navigate(`${pathname}/${record.id}`);
              }
            },
            style: { cursor: 'pointer' },
          })}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={<DeleteModal onClickDelete={handleDelete} />}
        />
      </Routes>
    </>
  );
};

export default MainPage;
